module.exports = ['$locationProvider', ($locationProvider) => {
  $locationProvider.html5Mode({
    enabled: true,
    requireBase: false,
  });
}];



// WEBPACK FOOTER //
// ./main/config/initializers/location.js